__turbopack_context__.v({
  "Exclusion": "sales-settings-display-module__t3zRQW__Exclusion",
  "SubCheckbox": "sales-settings-display-module__t3zRQW__SubCheckbox",
  "Table": "sales-settings-display-module__t3zRQW__Table",
  "disabled": "sales-settings-display-module__t3zRQW__disabled",
});
